import { useEffect, useState, type ReactNode } from 'react'
import { motion } from 'framer-motion'
import { CONNECTIVITEIT, MODULES, t } from '../content/content'
import { useKiosk } from '../state/store'
import { VEER } from './gedeeld'

/**
 * Connectiviteit → Warehouse Cockpit (flowchart 5 oktober). De site mag
 * volgens Linde officieel in een iframe (mail "How to insert
 * warehousecockpit.com", docs/warehousecockpit.md), dus hij staat hier in het
 * scherm, met de terugtegel als de vaste uitgang die §5.5 eist.
 *
 * Dit is het enige onderdeel dat internet nodig heeft. Zonder verbinding
 * laadt een iframe van een ander domein stil niets; daarom kijken we vooraf
 * naar `navigator.onLine` en tonen we dan een melding in plaats van een leeg
 * vlak. Een laadfout ná verbinding is van buitenaf niet te zien (cross-origin),
 * vandaar ook de laadmelding die pas weggaat als het frame zich meldt.
 */
export function Connectiviteit({ terug }: { terug: ReactNode }) {
  const taal = useKiosk((s) => s.taal)
  const module = MODULES.find((m) => m.id === 'connectiviteit')!
  const [online, setOnline] = useState(() => navigator.onLine)
  const [geladen, setGeladen] = useState(false)

  useEffect(() => {
    const bij = () => setOnline(navigator.onLine)
    window.addEventListener('online', bij)
    window.addEventListener('offline', bij)
    return () => { window.removeEventListener('online', bij); window.removeEventListener('offline', bij) }
  }, [])

  return (
    <>
      <motion.div
        className="kiosk-cockpit"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ ...VEER, delay: 0.5 }}
      >
        {online ? (
          <>
            {!geladen && <div className="kiosk-cockpit-melding kiosk-cockpit-laden">{t(CONNECTIVITEIT.laden, taal)}</div>}
            <iframe
              title={t(CONNECTIVITEIT.kop, taal)}
              src={CONNECTIVITEIT.url}
              onLoad={() => setGeladen(true)}
              allow="fullscreen"
              referrerPolicy="strict-origin-when-cross-origin"
            />
          </>
        ) : (
          <div className="kiosk-cockpit-melding">
            <div className="kiosk-tegel-nr">{module.nr}</div>
            <h2 className="kiosk-hero kiosk-hero-m">{t(CONNECTIVITEIT.kop, taal)}</h2>
            <p className="kiosk-onderkop">{t(CONNECTIVITEIT.offline, taal)}</p>
          </div>
        )}
      </motion.div>

      <div className="kiosk-actiebalk">
        {terug}
        <div className="kiosk-tegel kiosk-tegel-tekst">
          <span className="kiosk-tegel-nr">{module.nr}</span>
          <span className="kiosk-tegel-naam">{t(CONNECTIVITEIT.kop, taal)}</span>
          <span className="kiosk-tegel-sub">{t(CONNECTIVITEIT.intro, taal)}</span>
        </div>
      </div>
    </>
  )
}
